import React from "react";
import ComingSoon from "../components/ComingSoon";

const NBARatings = () => {
  return <ComingSoon pageName="NBA Player Ratings" />;
};

export default NBARatings;
